import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {MemberSt} from 'hiya-common/src/reducers/commonTypes'
import {useSelector} from 'react-redux'

export enum TabEnum {
  Daily = 0,
  Host = 1,
  Agency = 2,
  Time = 3,
}

export enum RoleEnum {
  no = 0,
  union = 1,
  anchor = 2,
}

export enum TimeLimitRole {
  union = 1,
  anchor = 2,
  nopromisse = 3,
  noanchor = 4,
}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=164405943
// 任务中心默认展示tab
export const GetTabList = createAsyncThunk(
  '/live/misc/get_mission_centre_user_info',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/misc/get_mission_centre_user_info',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=90608506
// 初始化信息: 奖品列表、日常/特殊任务列表、剩余宝石数量、单次抽奖消耗
export const GetDailyTask = createAsyncThunk(
  '/live/misc/user_job_center',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/misc/user_job_center',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711615
// 去玩游戏接口 一个通用的、游戏方面的任务去完成按钮的接口 -> 日常任务的完成接口
// 使用参考： goGame({ from: 'homepage_mission', game_tag: item.gameTag }) 未完成 存在gameTag
export const DoneDailyTask = createAsyncThunk(
  '/gamestore/common/game_mission_goto_complete',
  async (arg: any, store) => {
    const resp = await http.post(
      '/gamestore/common/game_mission_goto_complete',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 任务奖励领取 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90608507
// VIP 系列会返回一个vipeward boolean值 用于告知领奖是否有VIP奖励
export const getUserMissionAward = createAsyncThunk(
  '/live/misc/user_job_award',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/misc/user_job_award',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=155164577
// 日常任务飘屏幕
export const GetAwardSwiperList = createAsyncThunk(
  '/live/misc/user_job_lottery_list',
  async (arg: any, store) => {
    const resp = await http.post(
      '/live/misc/user_job_lottery_list',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 公会任务 公会信息
// http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711499
export const getUnionInfo = createAsyncThunk(
  'TaskCenter/union_task_info',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/get_union_task_info', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export const getLevelTarget = createAsyncThunk(
  'TaskCenter/getLevelTarget',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_level_target', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

export const getIncomeTarget = createAsyncThunk(
  'TaskCenter/getIncomeTarget',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_income_target_list',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data.data
  }
)

// 公会收入目标奖励接口
export const getIncomeReward = createAsyncThunk(
  'TaskCenter/getIncomeReward',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_income_target_reward',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data.data
  }
)

// 公会领取等级目标领取奖励接口
export const levelDraw = createAsyncThunk(
  'TaskCenter/levelDraw',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_level_draw', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 公会领取等级目标领取奖励接口
export const levelWeekGain = createAsyncThunk(
  'TaskCenter/levelWeekGain',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_level_week_target_gain',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// 公会收入目标领取奖励接口
export const incomeDraw = createAsyncThunk(
  'TaskCenter/levelDraw',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/union_task_income_draw', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 公会等级目标周维度接口
export const getWeekTarget = createAsyncThunk(
  'TaskCenter/getWeekTarget',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/union_task_level_week_target',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data.data
  }
)

// 主播任务 - 主播中心任务
// 主播等级首页数据  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390669
export const level_home_page = createAsyncThunk(
  'TaskCenter/live/union/home_page',
  async (p, store: any) => {
    const resp = await http.post(
      '/live/union/home_page',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播等级获取奖励  http://wiki.xunlei.cn/pages/viewpage.action?pageId=120390676
export const level_get_rewards = createAsyncThunk(
  'TaskCenter/live/union/get_rewards',
  async (p: {id: number}, store: any) => {
    const resp = await http.post(
      '/live/union/get_rewards',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 主播任务 - 单独页面任务
// 主播任务主页  http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711667
export const getInfo = createAsyncThunk(
  'TaskCenter/getInfo',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/anchor_task_home', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 公会领取等级目标领取奖励接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=91711672
export const receiveIncome = createAsyncThunk(
  'TaskCenter/receiveIncome',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/anchor_task_receive_income', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 限时任务接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164405993
export const get_time_limit_task = createAsyncThunk(
  'TaskCenter/get_time_limit_task',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/get_time_limit_task', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 限时任务领取接口 http://wiki.xunlei.cn/pages/viewpage.action?pageId=164409406
export const time_limit_rec = createAsyncThunk(
  'TaskCenter/new_union_act_reward',
  async (p: any, store: any) => {
    const resp = await http.post('/live/activity/new_union_act_reward', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 限时任务下注任务和收入任务领取  http://wiki.xunlei.cn/pages/viewpage.action?pageId=90612487
export const get_stage_done_reward = createAsyncThunk(
  'TaskCenter/new_union_act_reward',
  async (p: any, store: any) => {
    const resp = await http.post('/live/commonactivity/get_stage_done_reward', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 主播任务页面，获取主播信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=167777559
export const get_anchor_info = createAsyncThunk(
  'TaskCenter/get_anchor_info',
  async (p, store: any) => {
    const resp = await http.post('/live/activity/get_anchor_info', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 限时任务 新任务接口
export const mission_centre_task_list = createAsyncThunk(
  'TaskCenter/mission_centre_task_list',
  async (p, store: any) => {
    const resp = await http.post('/live/misc/mission_centre_task_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// 限时任务 领取接口
export const mission_centre_receive_award = createAsyncThunk(
  'TaskCenter/mission_centre_receive_award',
  async (p: any, store: any) => {
    const resp = await http.post('/live/misc/mission_centre_receive_award', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

// 1定值金币 2比例金币 3-12 其他类型奖励
export enum RewardType {
  coins = 1,
  multiCoins = 2,
}
// 0 未完成不可领取 1 可领取 2 已领取 3 未开始
export enum DrawStatus {
  notAvailable = 0,
  available = 1,
  received = 2,
  notStarted = 3,
}
export interface IReward {
  type: number
  num: number
  day: number
  pic: string
  desc?: string
  vip: number
}
export interface ILevelTargetInfo {
  id: number
  target: number
  current: number
  coins: number
  status: DrawStatus
  reward: Array<IReward>
  gain_status?: DrawStatus
}
export interface IIncomeTargetInfo {
  id: number
  start_time: string
  end_time: string
  count_down: number
  status: TaskStatus
  target: number
  current: number
  coins: number
  reward: Array<IReward>
  draw_status: DrawStatus
}
export interface IIncomeListItem {
  complete_num: number
  countdown: number
  current: number
  index: number
  list: Array<IIncomeTargetInfo>
}
// 1待开始 2进行中 3已结束
export enum TaskStatus {
  notStarted = 1,
  processing,
  over,
}
interface IReward2 {
  pic: string
  desc: string
}
interface IIncomeReward {
  target: number
  union_desc: Array<IReward2>
  anchor_desc: Array<IReward2>
}

export interface AnchorTaskItem {
  task_level: number
  start: number
  end: number
  cur_income: number
  diff_income: number
  reward: number
  status: DrawStatus
  special_rewards: [{url: string; desc: string}]
  is_show_reward: boolean
  is_show_special_rewards: boolean
}

interface AwardInfo {
  img: string
  name: string
  num: number
  unit?: string
}

export interface Record {
  name: string
  desc: string
  id: number
  target: number
  current: number
  reward: number
  status: DrawStatus
  icon: string
  reward_info: AwardInfo[]
}

export interface anchor_task_info {
  count_down: number
  status: DrawStatus
  list: Record[]
}

export interface limit_task_info {
  week_id: number
  anchor_task: anchor_task_info
  reward_list: {
    img: string
    name: string
  }[]
}

export enum reward_type {
  coin = 1,
  coincard = 2,
  privilege = 3,
}

export interface timeLimitTaskInfo {
  icon: string
  title: string
  desc: string
  color: string
  tag_color: string
  start_time: string
  end_time: string
}

export interface new_limit_task {
  week_id: number
  count_down: number
  task_list: Record[]
}

export interface OpNewUnionTaskInfo extends new_limit_task {
  job_id?: number
  job_system_id?: number
  job_tag?: string
}

export interface new_union_task_info_type extends timeLimitTaskInfo {
  union_task: Record[]
  role: TimeLimitRole
  ancor_task_list: limit_task_info[] // 周任务
  daily_anchor_task_list: limit_task_info[] // 日任务
  union_task_list: new_limit_task[] // 公会长任务 有关几个主播完成哪个任务公会长获得奖励
  week_id: number // 1开始和ancor_task_list中的id对应起来 当前的周数
  union_leader_task_list?: OpNewUnionTaskInfo[] // tuerqi公会长任务
  op_anchor_task_list?: OpNewUnionTaskInfo[] // tuerqi主播任务
  activity_id: number // 通用的任务id
  // leader_reward_pool: {
  //   type: reward_type
  //   value: number
  //   icon: string
  //   name: string
  // }
}

export interface StageInfo {
  stage_no: number
  stage_need: number
  stage_icon: string
  status: DrawStatus
  reward_list: [][]
  reward_infos: {
    reward_id: number
    reward_value: number
    desc_name: string
    desc_icon: string
    has_show_effect: boolean
    reward_num?: number
  }[]
}

export interface StageTaskInfo {
  stage_score: number
  stages: StageInfo[]
  expire_secs: number
  show_rec_button: boolean
  task_id: number // 后端待增加
  task_type: 1 | 2 // 1下注 2收礼
}

export interface NewTimeStageInfo {
  stage_no: number
  stage_need: number
  status: DrawStatus
  reward_list: Array<{
    img: string
    name: string
    num: number
    unit: 0 | 1
  }>
}

export interface NewTimeStageTaskInfo {
  task_title: string
  task_id: number
  task_content: string
  url: string
  value: number
  stages: NewTimeStageInfo[]
}

export interface NewTimeListItem {
  task_title: string
  task_id: number
  task_content: string
  url: string
  complete?: number
  total?: number
  icon?: string
  countdown?: number
  status?: DrawStatus
  reward_list?: Array<{
    img: string
    name: string
    num: number
    unit: 0 | 1 // 0 无 1D
  }>
  value?: number // 进阶任务 -- 待后端接口修改
  can_receive?: boolean
  stages?: NewTimeStageInfo[] // 进阶任务
}

export interface TaskSystemInfo {
  task_system_id: number
  title: string
  countdown: number
  tag: string // 标签（有值则优先展示，替换倒计时）
  tag_color: string // 标签 背景色
  list: NewTimeListItem[]
  stage_list: Array<NewTimeStageTaskInfo>
  rule_url: string // 规则页链接
}
export interface NewTimeList {
  icon: string
  bg_color: string
  activity_id: number
  tag: string // 标签（有值则优先展示，替换倒计时）
  tag_color: string // 标签 背景色
  title: string
  name: string
  rule_url: string
  start_time: string
  end_time: string
  list: TaskSystemInfo[]
}

export interface InitialStateType {
  tabInfo?: {
    // tab信息与默认信息
    tab_list: TabEnum[]
    default_tab: TabEnum
    union_id: number | string
    role: RoleEnum // 用户身份
    is_first: boolean // 第一次进入展示引导弹窗
    tab_num_map: {
      [key in TabEnum as string]: number // 每个tab的可领取任务数量
    }
  }
  dailyTask?: {
    dimonds_left: number
    pre_lottery_cost: number
    avatat: string
    lottery_list: any[]
    daliy_jobs: any[]
    improvement_jobs: any[]
    award_swiper_list: any[]
    vip_reward: boolean
    vip_homepage: string
  }
  unionTask?: {
    union_name: string // 公会名称
    union_id: number // 公会 ID
    union_mid: number // 公会长 MID
    name: string // 公会长名称
    avatar: string // 头像
    salary: number // 本月累计薪资
    anchors: number // 活跃主播数量
    is_rank: boolean // 是否展示榜单
    is_level_target: boolean // 是否展示等级目标
    is_level_week_target: boolean // 是否展示等级目标周维度
    is_income_target: boolean // 是否展示收入目标
    is_income_reward: boolean // 是否展示收入目标奖励
    is_grow: boolean // 是否展示成长（当前均隐藏）
    count_down?: number // 倒计时（类型不明确，假设为 number，可选）
    levelList: TaskDataType<ILevelTargetInfo>
    incomeList: Array<TaskDataType<IIncomeTargetInfo>>
    incomeRewardList: TaskDataType<IIncomeReward>
    weekLevelList: TaskDataType<ILevelTargetInfo>
    is_union_leader: boolean
  }
  anchorTask?: {
    // 主播信息
    anchorInfo: {
      id?: number
      name?: string
      avatar?: string
      effective_day?: number // 有效天数
      union_task_url?: string
    }
    // 主播中心任务
    ahchorCenterTask: {
      target?: number // 下一个目标值
      countdown?: number // 倒计时秒
      complete_num?: number // 已完成任务数
      receive_num?: number // 已领取数
      count_down?: number
      member?: MemberSt
      banners?: {
        id: number // banner id
        cover: string // banner图片
        link: string // banner跳转链接
        score: number // banner权重
      }[]
      anchor_info?: {
        union_id: number // 公会id
        days: number // 成为主播天数 （如果主播中途退出公会，则数据清零）
        new: 0 | 1 // 是否新主播 0:否 1:是
        level: number // 主播等级  0New 1Rising 2Super 3Silvier 4Golden 5Legend
        score: number // 当前分数
        stage_job_score: number // 等级任务进度
      }
      level_rewards?: {
        level: number // 主播等级 0New 1Rising 2Super 3Silvier 4Golden 5Legend
        min_score: number // 最低等级分数
        score: number // 主播等级分数
        rewards: {
          icon: string // icon
          desc: string // 描述
        }[]
      }[]
      stage_jobs?: {
        id: number // 阶段id
        need: number // 阶段需要值
        icon: string // 阶段任务ICON
        status: number // 0:未达到;1:目标达到;2:奖励已领取
        name: string // 阶段任务名称
      }[]
      jobs?: {
        id: number // 阶段id
        name: string
        status: number // 0:未达到;1:目标达到;2:奖励已领取
        jump_url: string // 跳转链接
        reward_cnt: number // 奖励钥匙数量
      }[]
    }
    // 单独页面任务
    acnhorPageTask: {
      member_info?: {
        id: number
        zy_id: number
        name: string
        avatar: string
      }
      diamond?: number
      effective_day?: number
      union_task_url?: string
      count_down?: number
      income_list?: Array<AnchorTaskItem>
      income_index?: number
      current?: number // 当前进度
      target?: number // 下一个目标值
      countdown?: number // 倒计时秒
      complete_num?: number // 已完成任务数
      receive_num?: number // 已领取数
    }
  }
  timeLimitTask?: {
    new_union_task_info?: new_union_task_info_type
    task_list?: StageTaskInfo[]
    list?: NewTimeList[]
  }
  curTab?: number // 当前所在的tab
}
interface TaskDataType<L> {
  list: Array<L>
  current: number // 当前进度
  target: number // 下一个目标值
  countdown: number // 倒计时秒
  complete_num: number // 已完成任务数
  receive_num: number // 已领取数
}

const initialState: InitialStateType = {}
const initData: InitialStateType = {
  dailyTask: {
    dimonds_left: 0, // 剩余宝石数
    pre_lottery_cost: 0, // 单次抽奖消耗
    avatat: '', // 用户头像
    lottery_list: [], // 奖品列表
    daliy_jobs: [], // 日常任务
    improvement_jobs: [], // 特殊任务
    award_swiper_list: [], // swiper轮播信息
    vip_reward: false,
    vip_homepage: '',
  },
  unionTask: {
    union_name: '', // 公会名称
    union_id: 0, // 公会 ID
    union_mid: 0, // 公会长 MID
    name: '', // 公会长名称
    avatar: '', // 头像
    salary: 0, // 本月累计薪资
    anchors: 0, // 活跃主播数量
    is_rank: false, // 是否展示榜单
    is_level_target: false, // 是否展示等级目标
    is_level_week_target: false, // 是否展示等级目标周维度
    is_income_target: false, // 是否展示收入目标
    is_income_reward: false, // 是否展示收入目标奖励
    is_grow: false, // 是否展示成长
    count_down: 0, // 倒计时（如果是可选，也可以省略）
    levelList: {
      list: [],
      current: 0, // 当前进度
      target: 0, // 下一个目标值
      countdown: 0, // 倒计时秒
      complete_num: 0, // 已完成任务数
      receive_num: 0, // 已领取数
    },
    incomeList: [],
    incomeRewardList: {
      list: [],
      current: 0, // 当前进度
      target: 0, // 下一个目标值
      countdown: 0, // 倒计时秒
      complete_num: 0, // 已完成任务数
      receive_num: 0, // 已领取数
    },
    weekLevelList: {
      list: [],
      current: 0, // 当前进度
      target: 0, // 下一个目标值
      countdown: 0, // 倒计时秒
      complete_num: 0, // 已完成任务数
      receive_num: 0, // 已领取数
    },
    is_union_leader: false,
  },
  anchorTask: {
    anchorInfo: {},
    ahchorCenterTask: {},
    acnhorPageTask: {},
  },
  tabInfo: {
    tab_list: [0, 1, 2, 3],
    default_tab: undefined,
    role: undefined,
    is_first: false,
    tab_num_map: {
      0: 0,
      1: 0,
      2: 0,
      3: 0,
    },
    union_id: undefined,
  },
  timeLimitTask: {},
  curTab: 0,
}

export const TaskCenterSlice = createSlice({
  name: 'TaskCenter',
  initialState,
  reducers: {
    initData: (state) => {
      Object.assign(state, initData)
    },
    updateCurTab: (state, action: PayloadAction<any>) => {
      Object.assign(state, {
        curTab: action.payload,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(GetTabList.fulfilled, (state, action) => {
      Object.assign(state.tabInfo, action.payload) // TODO 开发注释
    })
    builder.addCase(GetDailyTask.fulfilled, (state, action) => {
      Object.assign(state.dailyTask, action.payload)
    })
    builder.addCase(GetAwardSwiperList.fulfilled, (state, action) => {
      const {dailyTask} = state
      const {list} = action.payload
      Object.assign(state.dailyTask, {
        ...dailyTask,
        award_swiper_list: list,
      })
    })
    // 工会任务
    builder
      .addCase(getUnionInfo.fulfilled, (state, action) => {
        Object.assign(state.unionTask, {
          ...action.payload,
        })
      })
      .addCase(getLevelTarget.fulfilled, (state, action) => {
        const {
          list = [],
          countdown = 0,
          current = 0,
          target = 0,
          complete_num = 0,
          receive_num = 0,
        } = action.payload
        Object.assign(state.unionTask, {
          levelList: {
            list,
            current,
            target,
            countdown,
            complete_num,
            receive_num,
          },
        })
      })
      .addCase(getIncomeTarget.fulfilled, (state, action) => {
        const {list = []} = action.payload
        Object.assign(state.unionTask, {
          incomeList: list || [],
        })
      })
      .addCase(getWeekTarget.fulfilled, (state, action) => {
        const {
          list = [],
          countdown = 0,
          current = 0,
          target = 0,
          complete_num = 0,
          receive_num = 0,
          is_union_leader,
        } = action.payload
        Object.assign(state.unionTask, {
          weekLevelList: {
            list,
            current,
            target,
            countdown,
            complete_num,
            receive_num,
          },
          is_union_leader,
        })
      })
      .addCase(getIncomeReward.fulfilled, (state, action) => {
        const {
          list = [],
          countdown = 0,
          current = 0,
          target = 0,
          complete_num = 0,
          receive_num = 0,
          is_union_leader,
        } = action.payload
        Object.assign(state.unionTask, {
          incomeRewardList: {
            list,
            current,
            target,
            countdown,
            complete_num,
            receive_num,
          },
        })
      })
    // 主播任务 -- 主播中心任务
    builder.addCase(level_home_page.fulfilled, (state, action) => {
      Object.assign(state.anchorTask.ahchorCenterTask, action.payload)
    })
    builder.addCase(getInfo.fulfilled, (state, action) => {
      Object.assign(state.anchorTask.acnhorPageTask, action.payload)
    })
    builder.addCase(get_anchor_info.fulfilled, (state, action) => {
      Object.assign(state.anchorTask.anchorInfo, action.payload)
    })
    // 限时任务
    builder.addCase(get_time_limit_task.fulfilled, (state, action) => {
      Object.assign(state.timeLimitTask, action.payload)
    })
    builder.addCase(mission_centre_task_list.fulfilled, (state, action) => {
      Object.assign(state.timeLimitTask, action.payload)
    })
  },
})
export default TaskCenterSlice.reducer
export const TaskCenterActions = TaskCenterSlice.actions
export const useTaskCenterState = () => {
  const data = useSelector((state) => state.TaskCenter)
  return data
}
